'use client';

import type { StateAbbreviation } from '@repo/supergraph/marketplace/types';
import { useCallback } from 'react';
import { useGeo } from '../../../GeoProvider/hook';
import { MobileFilters } from './index';

export const MobileFiltersWithGeo = ({
  slug,
  initialLocation,
  analyticsProps,
}: {
  slug: string;
  initialLocation?: StateAbbreviation;
  analyticsProps: { actionSection: string; pageIdentifier: string };
}) => {
  const { setRegionCode, initialRegionCode, regionCode } = useGeo();

  const handleLocationReset = useCallback(() => {
    setRegionCode(initialRegionCode as StateAbbreviation);
  }, [initialRegionCode, setRegionCode]);

  return (
    <MobileFilters
      slug={slug}
      initialLocation={initialLocation}
      analyticsProps={analyticsProps}
      onLocationReset={handleLocationReset}
      initialClientRegion={initialRegionCode}
      regionCode={regionCode}
    />
  );
};
